import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createQuestion,
  createQuestionType,
  deleteQuestion,
  deleteQuestionType,
  getQuestionList,
  getQuestionType,
  updateQuestion,
  updateQuestionType,
  gameList,
  gameNewlist,
  createGameNews,
  uploadGamePicture,
  deleteGameList,
  changeGameManegentNews,
  createGame,
  deleteGame,
  changeGame,
  uploadGamesPicture,
  outOrInGame
} from "@/api/modules/helpCenter";

// 常见问题列表
export const getQuestionListAction = createAsyncThunk(
  "helpCenter/list",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getQuestionList(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 创建常见问题
export const createQuestionAction = createAsyncThunk(
  "helpCenter/createQuestion",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await createQuestion(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 修改常见问题
export const updateQuestionAction = createAsyncThunk(
  "helpCenter/updateQuestion",
  async ({ questionId, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await updateQuestion(questionId, params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 删除常见问题
export const deleteQuestionAction = createAsyncThunk(
  "helpCenter/deleteQuestion",
  async (questionId: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await deleteQuestion(questionId);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 常见分类
export const getQuestionTypeAction = createAsyncThunk(
  "helpCenter/getQuestionType",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getQuestionType(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 创建常见问题
export const createQuestionTypeAction = createAsyncThunk(
  "helpCenter/createQuestionType",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await createQuestionType(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 修改常见问题
export const updateQuestionTypeAction = createAsyncThunk(
  "helpCenter/updateQuestionType",
  async ({ categoryId, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await updateQuestionType(categoryId, params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 删除常见问题
export const deleteQuestionTypeAction = createAsyncThunk(
  "helpCenter/deleteQuestionType",
  async (categoryId: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await deleteQuestionType(categoryId);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);


export const gameListAction = createAsyncThunk(
  "helperCenter/getGameList",
  async (params: any) => {
    const result: any = await gameList(params)
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)


export const gameNewlistAction = createAsyncThunk(
  "helperCenter/gameNewlist",
  async (params: any) => {
    const result: any = await gameNewlist(params)
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)

export const createGameNewsAction = createAsyncThunk(
  "helperCenter/createGameNews",
  async (data: any) => {
    const result: any = await createGameNews(data)
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)

export const uploadGamePictureAction = createAsyncThunk(
  'helperCenter/uploadGamePicture',
  async (data: any) => {
    const result: any = await uploadGamePicture(data)
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  })

export const deleteGameListAction = createAsyncThunk(
  'helperCenter/deleteGameList',
  async (informationId: any) => {
    const result: any = await deleteGameList(informationId)
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  })

export const changeGameManegentNewsAction = createAsyncThunk(
  ('helperCenter/changeGameManegentNew'), async ({ informationId, data }: any) => {
    const result: any = await changeGameManegentNews(informationId, data)
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  })

export const createGameAction = createAsyncThunk(
  ('helperCenter/createGame'), async (params: any) => {
    const result: any = await createGame(params)
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  })


export const deleteGameAction = createAsyncThunk(
  'helperCenter/deleteGame',
  async (gameId: any) => {
    const result: any = await deleteGame(gameId)
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  })

export const changeGameAction = createAsyncThunk(
  'helperCenter/changeGame', async ({ gameId, params }: any) => {
    const result: any = await changeGame(gameId, params)
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  })

export const uploadGamesPictureAction = createAsyncThunk(
  'helperCenter/uploadGames',
  async (params: any) => {
    const result: any = await uploadGamesPicture(params)
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)

// 游戏转入转出明细
export const outOrInGameAction = createAsyncThunk(
  'game/outOrInGame',
  async (params: any) => {
    const result: any = await outOrInGame(params)
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)